export default __webpack_public_path__ + "weibo-website-logo.png";